// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3p-sB","head":"ProcedureTableInfo_head__1pyT4"};